/**
 * Created by hp on 2017/8/31.
 */
import React, {Component} from 'react';
import axios from 'axios';
import {Cells, Cell, CellBody} from 'react-weui';
import {Page} from '../components';
import {WKPreload, WKInfiniteScroll, WKNoData} from '../components/wk';
import {renderMoney, TimeStream} from "../utils";
import '../css/page/WithdrawApplyRecordPage.css';


class WithdrawApplyRecordPage extends Component {
    constructor() {
        super();
        this.renderStatus = this.renderStatus.bind(this);
        this.handleMore = this.handleMore.bind(this);
        this.handleData = this.handleData.bind(this);
        this.state = {
            initialized: false,
            withdraws: [],
            hasMore: false,
            loading: false,
            nextOffset: 0,
        }
    }

    renderStatus(fee, status) {
        let result = '';
        switch (status) {
            case 'processing':
                result = `提现${fee}元（处理中）`;
                break;
            case 'success':
                result = `提现${fee}元（已成功）`;
                break;
            case 'rejected':
                result = `提现${fee}元（已拒绝）`;
                break;
            case 'reviewing':
                result = `提现${fee}元（审核中）`;
                break;
            case 'fail':
                result = `提现${fee}元（提现失败）`;
                break;
            default:
                break;
        }
        return result;
    }

    handleData(nextOffset) {
        nextOffset = nextOffset ? nextOffset : 0;
        this.setState({
            loading: true
        });
        axios.get(`/api/wallet/withdraw/record?offset=${nextOffset}`).then(res => {
            if (res.data.code === 0) {
                let data = res.data.data;
                this.setState({
                    loading: false
                });
                if (nextOffset) {
                    this.setState({
                        hasMore: data.has_more,
                        withdraws: [...this.state.withdraws, ...data.withdraws],
                        nextOffset: data.next_offset
                    })
                } else {
                    this.setState({
                        initialized: true,
                        hasMore: data.has_more,
                        withdraws: data.withdraws,
                        nextOffset: data.next_offset
                    })
                }
            }
        });
    }

    handleMore() {
        const {nextOffset, hasMore} = this.state;
        if (hasMore) {
            this.handleData(nextOffset);
        }
    }

    componentDidMount() {
        this.handleData();
    }

    render() {
        const {initialized, withdraws, hasMore, loading} = this.state;
        if (!initialized) {
            return <WKPreload/>;
        }

        return (
            <Page className="withdraw-apply-record-page">
                <div className="wk-inner-page">
                    <div className="top-bar">
                        提现记录
                    </div>

                    <Cells>
                        {withdraws.length > 0 ?
                            withdraws.map((item, index) => (
                                <Cell key={index}>
                                    <CellBody>
                                        <div className="title">
                                        <span
                                            className="fl">{this.renderStatus(renderMoney(item.fee), item.status)}</span>
                                            <span className="fr time">{TimeStream(item.create_timestamp)}</span>
                                        </div>
                                        {item.status === 'success' &&
                                        <div className="tips">
                                            到账{renderMoney(item.income)}元，
                                            {item.channel === 'wechat' && '微信'}
                                            {item.channel === 'alipay' && '支付宝'}
                                            扣除手续费{renderMoney(item.cutoff)}元
                                        </div>
                                        }
                                        {(item.status === 'rejected' || item.status === 'fail') &&
                                        <div className="tips error-tips">{item.info}</div>
                                        }
                                    </CellBody>
                                </Cell>
                            ))
                            :
                            <WKNoData />
                        }
                    </Cells>

                    <WKInfiniteScroll onTouchBottom={this.handleMore} isKill={!hasMore} isShowLoading={true} isStop={loading}/>
                </div>
            </Page>
        )
    }
}

export default WithdrawApplyRecordPage;


// WEBPACK FOOTER //
// ./src/pages/WithdrawApplyRecordPage.js